import { SearchProps } from './types'
import { twMerge } from 'tailwind-merge'

export const Overlay = ({ children, className, ref }: SearchProps) => {
  return (
    <div className={twMerge('w-full h-full bg-white', className)} ref={ref}>
      {children}
    </div>
  )
}
